(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const sticky = document.querySelector('[data-sooo-sticky-atc]');
    const stickyButton = document.querySelector('[data-sooo-sticky-atc-button]');

    if (sticky && stickyButton) {
      const primaryButton =
        document.querySelector('.js-add-to-cart') ||
        document.querySelector('product-form button[type="submit"]') ||
        document.querySelector('form[action*="/cart/add"] button[type="submit"]');

      if (primaryButton) {
        const updateSticky = () => {
          const primaryRect = primaryButton.getBoundingClientRect();
          sticky.hidden = !(window.scrollY > window.innerHeight * 0.65 && primaryRect.bottom < 0);
        };

        stickyButton.addEventListener('click', () => primaryButton.click());
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky, { passive: true });
        updateSticky();
      }
    }

    document.querySelectorAll('a[href^="mailto:"]').forEach((link) => {
      link.setAttribute('aria-label', `Email SOOO at ${link.textContent.trim() || 'hello@sooo.shop'}`);
    });
  });
})();
